
// see visualization @ https://docs.google.com/document/d/1GCQVVh6Ue0DrSiaHLYZ4zasDBxZSEi6kYt1aHgD_afo/edit#heading=h.rvp51c62r3qx
const attackRegions = {
    // Heart
    1:  { key: "1",     name: "Region 1" },
    2:  { key: "2",     name: "Region 2" },
    3:  { key: "3",     name: "Region 3" },
    4:  { key: "4",     name: "Region 4" },
    5:  { key: "5",     name: "Region 5" },
    6:  { key: "6",     name: "Region 6" },
    7:  { key: "7",     name: "Region 7" },
    8:  { key: "8",     name: "Region 8" },
    9:  { key: "9",     name: "Region 9" },
    // Shadow
    11:  { key: "11",     name: "Region 11" },
    12:  { key: "12",     name: "Region 12" },
    13:  { key: "13",     name: "Region 13" },
    14:  { key: "14",     name: "Region 14" },
    15:  { key: "15",     name: "Region 15" },
    16:  { key: "16",     name: "Region 16" },
    17:  { key: "17",     name: "Region 17" },
    18:  { key: "18",     name: "Region 18" },
    19:  { key: "19",     name: "Region 19" },
    // Chase
    21:  { key: "21",     name: "Region 21" },
    22:  { key: "22",     name: "Region 22" },
    23:  { key: "23",     name: "Region 23" },
    24:  { key: "24",     name: "Region 24" },
    25:  { key: "25",     name: "Region 25" },
    26:  { key: "26",     name: "Region 26" },
    27:  { key: "27",     name: "Region 27" },
    28:  { key: "28",     name: "Region 28" },
    29:  { key: "29",     name: "Region 29" },
    // Waste
    31:  { key: "31",     name: "Region 31" },
    32:  { key: "32",     name: "Region 32" },
    33:  { key: "33",     name: "Region 33" },
    34:  { key: "34",     name: "Region 34" },
    35:  { key: "35",     name: "Region 35" },
    36:  { key: "36",     name: "Region 36" },
    37:  { key: "37",     name: "Region 37" },
    38:  { key: "38",     name: "Region 38" },
    39:  { key: "39",     name: "Region 39" },
};

export default attackRegions;